import { Button, Typography, useTheme } from '@mui/material';
import Paper from 'components/paper';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';

const NotFound: React.FC = () => {
  const history = useHistory();
  const theme = useTheme();

  return (
    <Paper
      transparent
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
      }}>
      <Typography variant="h3" color={theme.palette.common.white}>
        <FormattedMessage id="general.pageNotFound.title" />
      </Typography>
      <Typography color={theme.palette.common.white}>
        <FormattedMessage id="general.pageNotFound.description" />
      </Typography>
      <Button variant="contained" onClick={() => history.push('/overview')}>
        <FormattedMessage id="general.pageNotFound.goToOverview" />
      </Button>
    </Paper>
  );
};

export default NotFound;
